import { List,Record } from "immutable";

import syncFieldTypes from "../../../constants/syncFieldTypes";
import createFromJS from "../../createFromJS";

export const SyncCustomFieldRecord = Record({
  id: null, // The id of what field/type/property is being synced from the timeline
  label: null,
  options: List(),
  type: syncFieldTypes.TEXT
});

const data = {
  collections: {
    options: "SyncCustomFieldOptionRecord"
  }
};
createFromJS.registerCallback("SyncCustomFieldRecord", createFromJS.createNestedCallback(SyncCustomFieldRecord, data));
